<template>
  <svg 
    class="icon"
    style="width: 14px;height: 14px;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024"
    version="1.1" xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M342.3 101.9L752.4 512 342.3 922.1l-70.7-70.7L611 512 271.6 172.6l70.7-70.7z" />
  </svg>
</template>